import styled from 'styled-components';
import { theme } from '../../../../theme';

export const DivSorting = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  flex-shrink: 0 !important;
  margin-right: 24px;
  margin-bottom: 1rem;

  ${theme.up(theme.breakpoints.sm)} {
    margin-bottom: 0;
  }

  & > div {
    margin-bottom: 0;
    width: 280px;

    & button {
      font-size: 1rem;
      padding: 0.77rem 2.461rem 0.7rem 1.078rem;
    }

    & li.dropdown-item {
      font-size: 1rem;
    }
  }
`;

export const LabelSort = styled.label`
  font-weight: 600;
  margin: 0;
  margin-right: 12px;
`;
